export const cronMonitor = {
  title: '排程任務監控',
  menuLabel: '任務監控',
  buttons: {
    runNow: '立即執行',
    refresh: '重新整理',
  },
  sections: {
    cronJobInfo: '排程任務資訊',
    upcomingChanges: '即將變更',
    recentExecutions: '最近執行記錄',
  },
  fields: {
    schedule: '排程',
    nextRun: '下次執行',
    lastRun: '上次執行',
    template: '範本',
    effectiveDate: '生效日期',
    status: '狀態',
    reason: '原因',
    createdBy: '建立者',
    executionTime: '執行時間',
    applied: '已套用',
    errors: '錯誤',
  },
  status: {
    success: '成功',
    partialSuccess: '部分成功',
    failed: '失敗',
    overdue: '逾期',
    readyToApply: '準備套用',
  },
  messages: {
    noExecutionsYet: '尚未執行',
    noUpcomingChanges: '無即將進行的變更',
    noExecutionHistory: '無執行歷史記錄',
    failedToLoad: '載入排程狀態失敗',
    cronTriggeredSuccess: '排程任務觸發成功',
    cronTriggerFailed: '排程任務觸發失敗',
    appliedWithErrors: '已套用 %{applied} 個，%{errors} 個錯誤',
    inHours: '%{hours} 小時後',
  },
};
